import LabelRadioButtons from '../../../ui/labelRadioButtons';
import CommonLabelRadioButtons from '../../../ui/commonLabelRadioButton';
import { useSelector } from 'react-redux';
import FormField from '../../../ui/formField';
import TrusteeSectionAnnuity from './trustee';

const TrustSectionAnnuity = (props) => {
  const fieldData = useSelector((state) => state.policyOwnerAnnuityData);
  const { loading, error, formData } = fieldData;

  const trustTypeFieldData = formData?.data?.trustTypeOptions?.options;

  const trustAgreementChangeHandler = (event) => {
    props.setTrustAgreementFields(() => ({
      [event.target.id]: event.target.value,
    }));
  };
  const entityChangeHandler = (event) => {
    props.setTrustType(() => ({
      [event.target.id]: event.target.value,
    }));
    //setEntityOptionValue(event.target.value);
  };
  const onTrustNameFieldsChange = (event) => {
    props.setTrustName((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  return (
    <>
      {formData?.data && (
        <>
          <div className="flex">
            <h3>{formData?.data?.trustTypeOptions?.label}</h3>
            <CommonLabelRadioButtons
              options={trustTypeFieldData}
              onChangeHandler={entityChangeHandler}
            />

            <div className="line-separation layout-1"></div>
            {formData?.data?.trustName?.map((item) => {
              return (
                <FormField
                  key={item.id}
                  label={item.label}
                  id={item.id}
                  value={item.value}
                  type={item.type}
                  name={item.name}
                  placeholder={item.placeholder}
                  min={item.min}
                  max={item.max}
                  layoutType={item.layoutType}
                  onChangeHandler={onTrustNameFieldsChange}
                  selectOptions={item.selectOptions}
                  regex={item?.regex}
                  errorMessage={item?.errorMessage}
                  dropdownType={item.dropdownType}
                  validationType={item.validationType}
                />
              );
            })}
          </div>
          <TrusteeSectionAnnuity
            trustee={props.trustee}
            setTrustee={props.setTrustee}
            beneficiary={props.beneficiary}
            setBeneficiary={props.setBeneficiary}
          />
          <LabelRadioButtons
            label={formData?.data?.trustAgreementSection?.label}
            options={formData?.data?.trustAgreementSection?.options}
            id={formData?.data?.trustAgreementSection?.id}
            onChangeHandler={trustAgreementChangeHandler}
          />
          {props.trustAgreementFields['poa-trustAgreement-yes'] === 'yes' && (
            <div
              className={`label-value-wrapper field-remark-wrapper ${
                !formData?.data?.trustAgreementYesOptions?.value
                  ? 'value--empty'
                  : ''
              }`}
            >
              <label>{formData?.data?.trustAgreementYesOptions?.label}</label>
              <textarea
                name={formData?.data?.trustAgreementYesOptions?.id}
                id={formData?.data?.trustAgreementYesOptions?.id}
                onChange={(e) =>
                  props.setTrustAgreementYesValue(e.target.value)
                }
                defaultValue={formData?.data?.trustAgreementYesOptions?.value}
                placeholder={
                  formData?.data?.trustAgreementYesOptions?.placeholder
                }
              ></textarea>
            </div>
          )}
          <div className="line-separation layout-1"></div>
        </>
      )}
    </>
  );
};
export default TrustSectionAnnuity;
